app.service('instalmentCalculatorModal', function (orderUtils, loading, pageConfig, modal, front, simpleModal, log) {
	let $self, $body;
	let $instalments, $tabs, $instalmentTab, $rangeSlider, $tabSlider, $tabSliderList;
	let isInit = false;
	let currentTab = 0;
	let instalmentCode = '';
	let instalmentDuration = 0;
	let config;
	const props = {};
	let rangeSliderWidth, rangeSliderLength, rangeMin, rangeMax, rangeStep;
	let instalmentTabsData = [], overflowedInstalmentTabsCount = 0;
	
	function logEvent(params={}){
		params.id = 'order-instalment-modal';
		log.event(params);
	}

	function setActiveTab(props) {
		if(props && props.code) {
			$tabs.each(index => {
				const itemCode = $($tabs[index]).data('code').toString();
				const itemWarranty = $($tabs[index]).data('warranty').toString();
				const propsCode = props.code.toString();
				const propsWarranty = props.warrantyId ? props.warrantyId.toString() : "";
				if (itemCode === propsCode && itemWarranty === propsWarranty) {
					$instalmentTab = $($tabs[index]);
				}
			});
		} else {
			$instalmentTab = $($tabs[$instalments.data('active-tab')]);
		}
	}
	function setTabsInfoForSlider() {
		const scroll = $tabSlider.attr('data-scroll') / 1 || 0;
		const boxWidth = $tabSlider[0].offsetWidth;
		instalmentTabsData = [];
		overflowedInstalmentTabsCount = 0;
		let scrollTab = 0;
		$tabs.each(function(index, el){
			instalmentTabsData.push({
				instalmentIndex: el.dataset.instalment,
				offsetLeft: el.offsetLeft,
				width: el.offsetWidth,
				offsetToRight: el.offsetLeft + el.offsetWidth,
			})
			if (boxWidth < (el.offsetLeft + el.offsetWidth)) {
				overflowedInstalmentTabsCount++;
				if($(el).is($instalmentTab)){
					scrollTab=overflowedInstalmentTabsCount/1;
				}
			}
		});
		$tabSlider.attr('data-overflowed-elements', overflowedInstalmentTabsCount > scroll ? overflowedInstalmentTabsCount - scroll : 0);
		if(scrollTab){
			slideInstalmentTabs(scrollTab);
		}
	}

	function slideInstalmentTabs(direction) { 
		if(overflowedInstalmentTabsCount >= 0) {
			let scroll = $tabSlider.attr('data-scroll') / 1 || 0;
			scroll = scroll + direction;
			$tabSlider.attr('data-overflowed-elements', overflowedInstalmentTabsCount > scroll ? overflowedInstalmentTabsCount - scroll : 0)
			if (scroll) {
				if(front.getBrakepoint() === 'mobile'){
					$tabSlider[0].scrollLeft = ( instalmentTabsData[scroll].offsetLeft);
				}else{
					$tabSlider.attr('data-scroll', scroll);
					$tabSliderList.css('transform' , 'translateX('+ (-1 * instalmentTabsData[scroll].offsetLeft) + 'px)');
				}
			} else {
				if(front.getBrakepoint() === 'mobile'){
					$tabSlider[0].scrollLeft = ( instalmentTabsData[scroll].offsetLeft);
				} else {
					$tabSlider.removeAttr('data-scroll');
					$tabSliderList.css('transform' , 'translateX(0px)');
				}
			}
		}
	}
	function openInstalmentsOptions(props) {
		const initInstalmentDuration = parseInt(props && props.number);
		const initInstalmentCode = props && props.code;
		currentTab = $instalmentTab.data('instalment');
		instalmentCode = initInstalmentCode || $instalmentTab.data('code');
		instalmentDuration = initInstalmentDuration || $instalmentTab.data('duration');
		warranty = $instalmentTab.data('warranty');
		logEvent({f03:'open-tab', f04:instalmentCode, f05: instalmentDuration, f06: warranty});

		$instalments.attr('data-active-tab', currentTab);
		repaintRangeSlider(instalmentDuration);
	}
	function countFormat(count){
		if(count==1) {
			return '1 rata';
		} else if(count%10>1 && count%10<5 && (count<5 || count>21)) {
			return count + ' raty';
		} else {
			return count + ' rat';
		}
	}
	function startRangeSlider(event) {
		rangeSliderWidth = $rangeSlider.width();
		updateRangeSlider(event);
		$body.on('mousemove', updateRangeSlider).on('touchmove', function(e){
			if(e.originalEvent.touches && e.originalEvent.touches[0] && e.originalEvent.touches[0].target.classList.contains('js-instalment-thumb')){
				updateRangeSlider(e.originalEvent.touches[0]);
			}
		});
		
		$body.on('mouseup touchend mouseleave touchleave', stopRangeSlider);
	}
	function updateRangeSlider(event) {
		var x = event.clientX - $rangeSlider.offset().left;
		var y = event.clientY - $rangeSlider.offset().top;
		var duration = (Math.max(Math.min(Math.ceil((x / rangeSliderWidth) * rangeSliderLength),rangeSliderLength),1) - 1) * rangeStep + rangeMin;
		if (duration != instalmentDuration) {
			repaintRangeSlider(duration);
		}
	}
	function stopRangeSlider() {
		$body.off('mousemove touchmove', updateRangeSlider);
		$body.off('mouseup touchend mouseleave touchleave', stopRangeSlider);
	}
	function repaintRangeSlider(duration) {
		var $instalmentItem=$('.instalment-item[data-instalment='+currentTab+']');
		$rangeSlider = $('.js-instalment-slider', $instalmentItem);
		$thumb = $('.js-instalment-thumb', $rangeSlider);
		var $bar = $('.js-instalment-bar span', $rangeSlider);

		rangeSliderLength = $rangeSlider.data('size')/1;
		var $pricing = $('.js-instalment-pricing', $instalmentItem);
		var $warrantyDetailedInformation = $('.instalment-warranty-detailed-information', $instalmentItem);
		rangeMin = Math.max($pricing.first().data('option')/1, 1);
		rangeMax = Math.max($pricing.last().data('option')/1, 1);
		rangeStep = Math.max((rangeMax - rangeMin)/(rangeSliderLength-1), 1);

		if(duration){
			duration = Math.min(rangeMax, duration);
			duration = Math.max(rangeMin, duration);
			var position = (duration - rangeMin)/rangeStep + 1 ;
			if(position){

				instalmentDuration = duration;

				var $promotionPackage = $('.promotions-package-item[data-code="' + instalmentCode +'"]', $self);
				$promotionPackage.removeClass('promotions-package-item-visible')
				$promotionPackage.filter('[data-duration="' + duration + '"]').addClass('promotions-package-item-visible');
				
				if ($warrantyDetailedInformation.length > 0){
					// przeliczniki dla produktu ratalnego z ochroną
					var $warrantyDetailedInformation = $('.js-detailed-information-price[data-option=' + duration + ']');	// tutaj przełączamy ceny gwarancji na główwnej części kalkulatora
					$warrantyDetailedInformation.prevAll().removeClass('selected-pricing');
					$warrantyDetailedInformation.addClass('selected-pricing');
					$warrantyDetailedInformation.nextAll().removeClass('selected-pricing');
					var $detailedWarrantyPricing = $('.js-detailed-warranty-information-price[data-option=' + duration + ']', $instalmentItem);	// tutaj przełączamy gwarancje na opisie szcegółów tej opcji ratalnej
					$detailedWarrantyPricing.prevAll().removeClass('selected-pricing');
					$detailedWarrantyPricing.addClass('selected-pricing');
					$detailedWarrantyPricing.nextAll().removeClass('selected-pricing');
				}

				var $pricing = $('.js-instalment-pricing[data-option=' + duration + ']');
				$pricing.prevAll().removeClass('selected-pricing');
				$pricing.addClass('selected-pricing');
				$pricing.nextAll().removeClass('selected-pricing');

				$thumb.text(countFormat(duration));
				let count = 1 + rangeMax - rangeMin;
				let left = parseInt(100*(position-1)/(count-1))+'%'
			
				$thumb.css({
					left: left
				});
				$bar.css({
					width: left
				});

				// TODO: Kalkulator nie ma wpływu na ten bloczek (dodać komentarz w zadaniu)
				// operatorMaxInstalment.prepare(instalmentDuration);
			}
		}
	}

	function changeUserInstalmentOption(instalment, instalmentNumber){
		// wybór oferty ratalnej i ustawienie wartości w formularzu koszyka
		$('#instalment').val(instalment);
		$('#instalment-number').val(instalmentNumber);
		logEvent({f03:'set-option', f04:instalmentCode, f05: instalmentDuration});
		orderUtils.send('CHANGE_USER_INSTALMENT_OPTION', true);
	}
	function setElements() {
		$instalments = $('#instalments', $self);
		$tabs = $('.js-tab', $self);
		$tabSlider = $('.instalment-tabs-slider', $self);
		$tabSliderList = $('.instalment-tabs', $self);
		$rangeSlider = $('.js-instalment-slider', $self);
		currentTab = $('#instalments').data('active-tab') || 0;

		config = pageConfig.getData('order');
		props.code = config.maxWorthInstalmentCalculatorData ? config.maxWorthInstalmentCalculatorData.instalmentCode : '';
		props.number = config.maxWorthInstalmentCalculatorData ? config.maxWorthInstalmentCalculatorData.instalmentNumber : '';
		props.warrantyId = config.warrantyIdForInstalmentProductWithWarranty;

	}
	function setEvents() {
		$body.on('click', '.js-tab', function() { 
			$instalmentTab = $(this);
			openInstalmentsOptions();
		}).on('click', '.js-set-instalment-option', function() {
			changeUserInstalmentOption(instalmentCode, instalmentDuration);
		}).on('click', '.js-instalment-tab-left', function() {
			slideInstalmentTabs(-1);
		}).on('click', '.js-instalment-tab-right', function() {
			slideInstalmentTabs(1);
		}).on('click', '.js-show-instalment-example', function() {
			logEvent({f03:'rsso-preview'});
			simpleModal.generate({
				content: $('#' + $(this).data('simple-modal-id')).html(),
			});
		}).on('click', '.js-preview-warranty-details', function() {
			logEvent({f03:'warranty-description'});
			simpleModal.generate({
				content: $('#' + $(this).data('simple-modal-id')).html(),
				fullWidth: true,
				classList: 'modal-preview-instalment-warranty'
			});
		}).on('mousedown touchstart', '.js-instalment-slider', function(event) {
			startRangeSlider(event);
		}).on('dragstart', '.js-instalment-slider', function(event) {
			event.preventDefault();
		}).on('click', '.js-instalment-contact-info', function () {
			logEvent({f03:'open-contact'});
			info();
		});
	}
	function load(){
		loading.start();
		$.ajax({
			url: '/cart-instalment-calculator.ltr',
			success: function (html) {
				loading.stop();
				open(html);
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd ładowania kalkulatora', function(){
					loading.reload();
				});
			}
		});

	}
	function open(html) {
		if(!html){
			load();
			return;
		}
		modal.generate({
			id: 'modal-instalments-calculator',
			content: html,
			modifier: 'remodal-full-width',
			callbackOpen: function(){
				$self = $('#modal-instalments-calculator');
				setElements();
				setActiveTab(props);
				setTabsInfoForSlider();
				openInstalmentsOptions(props);
				logEvent({f03:'open'});
				if (!isInit) {
					$body = $('body');
					setEvents();
					isInit = true;
				}
			}
		});
		
	}
	function info(){
		simpleModal.generate({
			content: $('#instalment-contact-content').html()
		});
	}
	return {
		open
	};
});
